import React from "react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useLanguage } from "../../contexts/LanguageContext";
import {
  getPlatformShadow,
  PLATFORM_SHADOWS,
} from "../../constants/onedio/socialMediaSlides.js";

SwiperCore.use([Autoplay, Pagination]);

function SocialMediaIcon({ src, alt, platform }) {
  const shadowRgb = PLATFORM_SHADOWS[platform] || PLATFORM_SHADOWS.facebook;
  const isSvg = src.endsWith(".svg");

  return (
    <div className="relative shrink-0 w-[72px] h-[72px] sm:w-24 sm:h-24">
      <div className="absolute inset-0 rounded-[18px] sm:rounded-[22.5px] bg-[#EBEBEB]/25 backdrop-blur-[4px]" />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 sm:w-16 sm:h-16 rounded-[10px] sm:rounded-[12px]"
        style={{ boxShadow: getPlatformShadow(shadowRgb) }}
      >
        <div
          className={`w-full h-full rounded-[10px] sm:rounded-[12px] overflow-hidden flex items-center justify-center ${
            isSvg ? "bg-black" : "bg-transparent"
          }`}
        >
          <img
            src={src}
            alt={alt}
            className={`w-full h-full rounded-[8px] sm:rounded-[10px] ${
              isSvg ? "object-contain p-2 sm:p-3 invert" : "object-cover"
            }`}
          />
        </div>
      </div>
    </div>
  );
}

function SocialMediaCard({ item, slideLogo, slidePlatform, language }) {
  const logo = item.logo || slideLogo;
  const platform = item.platform || slidePlatform;
  const name = language === "EN" ? item.nameEN : item.name;
  const followerLabel = language === "EN" ? "Followers" : "Takipçi";

  return (
    <div className="flex items-center gap-3 sm:gap-[18px]">
      <div className="shrink-0 p-1 sm:p-2">
        <SocialMediaIcon src={logo} alt={name} platform={platform} />
      </div>
      <div className="flex flex-col gap-0.5 sm:gap-1 min-w-0">
        <span className="text-base sm:text-xl font-bold text-black leading-tight">
          {name}
        </span>
        <p className="text-black leading-none">
          <span className="text-2xl sm:text-[36px] font-bold">{item.count}</span>
          <span className="text-base sm:text-[22.5px] font-normal">
            {" "}
            {followerLabel}
          </span>
        </p>
      </div>
    </div>
  );
}

export default function SocialMediaSlider({ slides }) {
  const { language } = useLanguage();

  return (
    <div className="social-media-slider max-w-[760px] w-full">
      <Swiper
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        loop
        className="social-media-swiper"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="px-2 py-4 sm:px-6 sm:py-6 min-h-0 sm:min-h-[352px]">
              <div className="text-sm font-medium text-[#697883] mb-4 sm:mb-5">
                {language === "EN" ? slide.titleEN : slide.title}
              </div>
              <div className="social-media-grid grid grid-cols-1 sm:grid-cols-2 gap-x-4 sm:gap-x-6 gap-y-6 sm:gap-y-8">
                {slide.items.map((item) => (
                  <SocialMediaCard
                    key={item.name}
                    item={item}
                    slideLogo={slide.logo}
                    slidePlatform={slide.platform}
                    language={language}
                  />
                ))}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
